import axios from "axios";
// import toastr from 'toastr'
import { URL_CONFIG } from "../../_constants/Config/URL_CONFIG";
import history from "@history.js";
import toastr from "toastr";
import { fetchPeriodStartDate } from "../jsHelper";

const API_AUTH = axios.create({
  baseURL: URL_CONFIG.DEV_URL,
});

// Declare a Map to store the identification and cancellation functions for each request
const pending = new Map();
/**
 * Add Request
 * @param {Object} config
 */
/**
 * Remove Request
 * @param {Object} config
 */
const removePending = (config) => {
  const url = [
    config.method,
    config.url,
    // JSON.stringify(config.params),
    // JSON.stringify(config.data)
  ].join("&");

  if (pending.has(url)) {
    // If the current request identity exists in pending, you need to cancel the current request and remove it
    const cancel = pending.get(url);

    cancel(url);
    pending.delete(url);
  }
};

API_AUTH.interceptors.request.use(
  function (request) {
    const path = window.location.pathname;
    // removePending(request) // Check previous requests to cancel before the request starts
    // let flag = addPending(request) // Add current request to pending

    // if (flag) {
    const token = localStorage.getItem("jwt_token");
    request.headers.Authorization = token ? `Bearer ${token}` : "";
    request.headers.periodStartDate = fetchPeriodStartDate();
    if (token) {
      request.headers.currentPage = path;
    }

    return request;
    // }

    // return null;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API_AUTH.interceptors.response.use(
  (response) => {
    const { status } = response.data;

    // Handle unauthorized status sent in response body
    if (status === 401) {
      const token = localStorage.getItem("jwt_token");
      const path = window.location.pathname.split("/");

      if (token) {
        toastr.error(response.data.message || "Unauthorized");
      }

      localStorage.removeItem("auth_user");
      localStorage.removeItem("jwt_token");
      localStorage.removeItem("permissions");
      localStorage.removeItem("siteIds");

      const redirectPath = path.includes("mobile")
        ? "/mobile/auth/sign-in"
        : "/session/signin";

      history.push({ pathname: redirectPath });
    }

    return response;
  },
  (error) => {
    // Only remove from pending if you activate cancellation
    if (error && error.response) {
      removePending(error.response.config);
    }

    return Promise.reject(error);
  }
);

export default API_AUTH;
